export default __webpack_public_path__ + "static/media/ISILogo.34dd05fa.png";